import { Injectable } from '@angular/core';
import { Router, CanActivate } from '@angular/router';
import { AuthenticationService } from '../services/authentication.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements  CanActivate {
  constructor(private router: Router, private authenticationService: AuthenticationService) { }

  canActivate(): Observable<boolean> | boolean {
    if (this.authenticationService.isAuthenticated()) {
      return true;
    }
    return this.authenticationService.ensureSession().pipe(map(isAuthenticated => {
      if (!isAuthenticated) {
        this.router.navigate(['/login']);
      }
      return isAuthenticated;
    }));
  }
}
